import {memo, useMemo} from 'react';

import styled from 'styled-components';

import {media} from '~/shared/theme/utils';
import {PaymentMethodTypes} from '~/shared/consts/paymentConsts';
import {LayoutWithHeader} from '~/shared/components/LayoutWithHeader';
import {flexColumn} from '~/shared/theme/FlexLayout';
import {MoneycardOtlRuleManagement} from '~/shared/store/models';

import OtlRuleLimitations from './OtlRuleLimitations';
import OtlCreditCardList from './OtlCreditCardList';
import {ModifiedCreditCard} from './types';

const Root = styled.div`
  background-color: ${({theme}) => theme.colors.surface};
  ${flexColumn}
  padding: 32px 16px;
  width: 100%;
  ${media.minLargeMobile`
    padding: 32px;
  `}
  ${media.minDesktop`
    width: 500px;
  `}
`;

type OtlRuleSettingsProps = {
  moneycardId: string;
  addCreditCard: () => void;
  selectedCreditCard: number | null;
  setSelectedCreditCard: (selectedCreditCard: number | null) => void;
  onClose?: () => void;
  otlData: MoneycardOtlRuleManagement | null;
  onSuccess?: () => void;
  withoutHeader?: boolean;
  withoutCreditCardsList?: boolean;
  hideLimitations?: boolean;
};

const OtlRuleSettings = ({
  moneycardId,
  addCreditCard,
  selectedCreditCard,
  setSelectedCreditCard,
  onClose,
  otlData,
  onSuccess,
  withoutCreditCardsList,
  hideLimitations,
  withoutHeader,
}: OtlRuleSettingsProps) => {
  const {otlRule, userCreditcards} = otlData || {};

  const creditCardList = useMemo(
    () =>
      userCreditcards?.map<ModifiedCreditCard>(({creditcardId, cardLastDigits, cardType}) => ({
        creditcardId,
        creditCardType: cardType,
        cardLastDigits,
        paymentMethod: PaymentMethodTypes.CREDIT_CARD.toLowerCase(),
      }) || []),
    [userCreditcards],
  );

  if (hideLimitations && withoutCreditCardsList) {
    return null;
  }

  const content = (
    <Root>
      {!withoutCreditCardsList && (
        <OtlCreditCardList {...{addCreditCard, creditCardList, selectedCreditCard, setSelectedCreditCard}} />
      )}
      {!hideLimitations && <OtlRuleLimitations {...{moneycardId, otlRule, selectedCreditCard, onSuccess}} />}
    </Root>
  );

  if (withoutHeader) {
    return content;
  }

  return (
    <LayoutWithHeader onClick={onClose} titleKey="otl_assign_credit_card" showBackArrow>
      {content}
    </LayoutWithHeader>
  );
};
export default memo(OtlRuleSettings);
